import { render, staticRenderFns } from "./TabRolesManagement.vue?vue&type=template&id=3b2efe94&scoped=true"
import script from "./TabRolesManagement.vue?vue&type=script&lang=js"
export * from "./TabRolesManagement.vue?vue&type=script&lang=js"
import style0 from "./TabRolesManagement.vue?vue&type=style&index=0&id=3b2efe94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2efe94",
  null
  
)

export default component.exports